// PokeAlp — Layouts JS (v2.2)
// - wrapTitlePrice        : title + price côte à côte
// - moveQtyNextToButton   : quantity + bouton ATC côte à côte (sélecteur corrigé)
// - moveStockUnderVariants: badge stock repositionné SOUS le variant picker
(function () {
  'use strict';

  function moveQtyNextToButton() {
    // Fix : le block _quantity-selector.liquid produit
    // <div class="hdt-product-info__item hdt-flex"> — pas de classe
    // .hdt-product__quantity. On cible via le contenu interne.
    var qtyInner = document.querySelector('.hdt-product-info__list .hdt-product-form__quantity, .hdt-product-info__list .hdt-quantity-wrapp');
    var qty = qtyInner ? qtyInner.closest('.hdt-product-info__item') : null;

    if (!qty) {
      qty = document.querySelector('.hdt-product-info__list .hdt-product-info__item.hdt-product__quantity');
    }
    if (!qty || qty.dataset.paMoved === '1') return;

    var buyContainer = document.querySelector('.hdt-product-info__list .hdt-product-info__item.hdt-product__buy-button');
    if (!buyContainer) return;

    var submitBtn = buyContainer.querySelector('button[type="submit"].hdt-product-form__submit')
                  || buyContainer.querySelector('button[type="submit"]');
    if (!submitBtn) return;

    var form = submitBtn.closest('form') || buyContainer;
    var wrapper = form.querySelector('.pa-qty-cta-row');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'pa-qty-cta-row';
      submitBtn.parentNode.insertBefore(wrapper, submitBtn);
      wrapper.appendChild(qty);
      wrapper.appendChild(submitBtn);
    }
    qty.dataset.paMoved = '1';
  }

  function wrapTitlePrice() {
    var title = document.querySelector('.hdt-product-info__list .hdt-product-info__item.hdt-product__title');
    var price = document.querySelector('.hdt-product-info__list .hdt-product-info__item.hdt-product__price');
    if (!title || !price) return;
    if (title.dataset.paWrapped === '1') return;

    var list = title.parentNode;
    var wrapper = document.createElement('div');
    wrapper.className = 'pa-title-price-row hdt-product-info__item';
    list.insertBefore(wrapper, title);
    wrapper.appendChild(title);
    wrapper.appendChild(price);
    title.dataset.paWrapped = '1';
  }

  // v2.2 : déplacer le badge stock SOUS le variant picker.
  // Le badge est dans _product-meta-available (sous-bloc de meta),
  // il produit `.pa-inventory.pa-badges-row` avec un
  // <hdt-variant-inventory> dedans. On déplace ce div sans casser
  // sa liaison JS (l'attribut `form=` reste OK).
  function moveStockUnderVariants() {
    var badge = document.querySelector('.hdt-product-info__list .pa-inventory.pa-badges-row, .hdt-product-info__list .hdt-product-info__item.pa-inventory');
    if (!badge || badge.dataset.paStockMoved === '1') return;

    // Trouver le DERNIER variant picker (au cas où il y en a plusieurs)
    var pickers = document.querySelectorAll('.hdt-product-info__list .hdt-product-info__item.hdt-product__variant-picker');
    var picker = pickers[pickers.length - 1];
    if (!picker) return;

    // Insérer juste après le picker
    picker.parentNode.insertBefore(badge, picker.nextSibling);
    badge.classList.add('pa-moved-under-variants');
    badge.dataset.paStockMoved = '1';
  }

  function run() {
    try { wrapTitlePrice(); } catch (e) {}
    try { moveStockUnderVariants(); } catch (e) {}
    try { moveQtyNextToButton(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(run, 400);
  setTimeout(run, 1200);

  // Observer pour capturer les rerender dynamiques (changement de
  // variante, ajout par une app Shopify, etc.)
  if (window.MutationObserver) {
    var debounce;
    var obs = new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(run, 100);
    });
    obs.observe(document.body, { childList: true, subtree: false });
  }
})();
